import { render, staticRenderFns } from "./PlayerAvatarPlaceholder.vue?vue&type=template&id=3a7fdf8d&scoped=true"
import script from "./PlayerAvatarPlaceholder.vue?vue&type=script&lang=js"
export * from "./PlayerAvatarPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7fdf8d",
  null
  
)

export default component.exports